import React, { useEffect, useState } from "react";
import "./Header.scss";
import { CiMenuBurger } from "react-icons/ci";
import logo from "../../../Assets/sonasons1.png";
import { IoMdNotifications } from "react-icons/io";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import ListItemButton from "@mui/material/ListItemButton";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import { IoChevronBackOutline } from "react-icons/io5";
import { IoReloadCircle } from "react-icons/io5";
import { menuDrawer } from "../../../Recoil/atom";
import { useRecoilState } from "recoil";
import Avatar from "../../../VuexyCompo/avatar";

const Header = ({ otherPage, title, handleRefresh }) => {
  const [open, setOpen] = useRecoilState(menuDrawer);
  const [expanded, setExpanded] = useState(false);
  const [allProfileData, setAllProfileData] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    const storedProfileData = sessionStorage.getItem("profileData");
    if (storedProfileData) {
      setAllProfileData(JSON.parse(storedProfileData));
    }
  }, [open]);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const handleAccordionToggle = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleNavigation = (path) => {
    setOpen(false);
    navigate(path);
  };

  const DrawerList = (
    <Box
      sx={{ width: 250, marginTop: "0px" }}
      role="presentation"
      onClick={() => toggleDrawer(false)}
    >
      <div
        style={{
          padding: "5px 0px",
          display: "flex",
          flexDirection: "column",
          gap: "5px",
        }}
      >
        <div className="header_top_profile">
          <Avatar
            skin="light"
            color="success"
            variant="rounded"
            sx={{ width: 42, height: 42, borderRadius: 50 }}
            src={
              allProfileData?.ImagePath ||
              "https://media.istockphoto.com/id/1337144146/vector/default-avatar-profile-icon-vector.jpg?s=612x612&w=0&k=20&c=BIbFwuv7FxTWvh5S3vB6bkT0Qv8Vn8N5Ffseq84ClGI="
            }
          />
          <div>
            <p style={{ margin: "0px", fontWeight: 600, fontSize: "14px" }}>
              {allProfileData?.firstname} {allProfileData?.lastname}
            </p>
            <p
              style={{
                margin: "-2px 0px 0px 0px",
                fontSize: "12px",
              }}
            >
              {allProfileData?.UserID}
            </p>
          </div>
        </div>
        <Accordion className="HeaderMenu_accordion">
          <ListItemButton onClick={() => handleNavigation("/employee")}>
            <Typography className="HeaderMenu_Without_Sub">Employee</Typography>
          </ListItemButton>
        </Accordion>
        <Accordion
          expanded={expanded === "menu1"}
          onChange={handleAccordionToggle("menu1")}
          className="HeaderMenu_accordion"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="menu1-content"
            id="menu1-header"
          >
            <Typography className="HeaderMenu_Without_Sub">Reports</Typography>
          </AccordionSummary>
          <AccordionDetails className="headerSub_deatil_mainDiv">
            <ListItemButton onClick={() => handleNavigation("/SalesReport")}>
              <p className="headerMenu_sub">Sale</p>
            </ListItemButton>
            <ListItemButton onClick={() => handleNavigation("/OrderReport")}>
              <p className="headerMenu_sub">Order</p>
            </ListItemButton>
            <ListItemButton onClick={() => handleNavigation("/WipReport")}>
              <p className="headerMenu_sub">WIP</p>
            </ListItemButton>
            <ListItemButton onClick={() => handleNavigation("/LossReport")}>
              <p className="headerMenu_sub">Loss Report</p>
            </ListItemButton>
            <ListItemButton onClick={() => handleNavigation("/StockReport")}>
              <p className="headerMenu_sub">Stock Report</p>
            </ListItemButton>
            <ListItemButton onClick={() => handleNavigation("/InfoReport")}>
              <p className="headerMenu_sub">Info Report</p>
            </ListItemButton>
            {/* <ListItemButton onClick={() => handleNavigation("/SampleReport")}>
              <p className="headerMenu_sub">Sample Report</p>
            </ListItemButton> */}
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "menu2"}
          onChange={handleAccordionToggle("menu2")}
          className="HeaderMenu_accordion"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="menu1-content"
            id="menu1-header"
          >
            <Typography className="HeaderMenu_Without_Sub">Action</Typography>
          </AccordionSummary>
          <AccordionDetails className="headerSub_deatil_mainDiv">
            <ListItemButton
              onClick={() => handleNavigation("/MeatalPriceUpdate")}
            >
              <p className="headerMenu_sub">Metal Price Update</p>
            </ListItemButton>
          </AccordionDetails>
        </Accordion>

        <Accordion className="HeaderMenu_accordion">
          <ListItemButton onClick={() => handleNavigation("/Notification")}>
            <Typography className="HeaderMenu_Without_Sub">
              Notification
            </Typography>
          </ListItemButton>
        </Accordion>

        <Accordion className="HeaderMenu_accordion">
          <ListItemButton onClick={() => handleNavigation("/TopReports")}>
            <Typography className="HeaderMenu_Without_Sub">
              Top 10 Performance Report
            </Typography>
          </ListItemButton>
        </Accordion>

        <Accordion className="HeaderMenu_accordion">
          <ListItemButton onClick={() => handleNavigation("/support")}>
            <Typography className="HeaderMenu_Without_Sub">Support</Typography>
          </ListItemButton>
        </Accordion>

        <Accordion className="HeaderMenu_accordion">
          <ListItemButton onClick={() => handleNavigation("/privacy-policy")}>
            <Typography className="HeaderMenu_Without_Sub">
              Privacy Policy
            </Typography>
          </ListItemButton>
        </Accordion>

        {/* <Accordion className="HeaderMenu_accordion">
          <ListItemButton onClick={() => handleNavigation("/LiquidityTracker")}>
            <Typography className="HeaderMenu_Without_Sub">
              Liquidity Tracker
            </Typography>
          </ListItemButton>
        </Accordion>

        <Accordion className="HeaderMenu_accordion">
          <ListItemButton onClick={() => handleNavigation("/TvConnect")}>
            <Typography className="HeaderMenu_Without_Sub">
              Tv Connect
            </Typography>
          </ListItemButton>
        </Accordion>

         <Accordion className="HeaderMenu_accordion">
          <ListItemButton onClick={() => handleNavigation("/IpAddressManagement")}>
            <Typography className="HeaderMenu_Without_Sub">
              IP Address Management
            </Typography>
          </ListItemButton>
        </Accordion> */}

        <p className="versionText">V 1.0.1</p>
      </div>
    </Box>
  );

  return (
    <header>
      {otherPage == true ? (
        <div className="Common_header">
          <Button className="backErrowButton">
            <IoChevronBackOutline
              // style={{ height: "27px", width: "27px", color: "#ad9696" }}
              style={{ height: "27px", width: "27px", color: "#5e5e5e" }}
              onClick={() => navigate(-1)}
            />
          </Button>
          <p className="common_header_title">{title}</p>
        </div>
      ) : (
        <div className="headerMain">
          <div className="headerR">
            <CiMenuBurger
              style={{ height: "25px", width: "25px" }}
              onClick={toggleDrawer(true)}
            />
          </div>
          <div className="headerCe">
            <p className="HeaderMain_Title">
              ADMIN
              <spna style={{ fontWeight: 200, marginLeft: "3px" }}>APP</spna>
            </p>
          </div>
          <div className="eaderLef">
            <Button className="refreshBtn">
              <IoReloadCircle
                style={{ height: "30px", width: "30px" }}
                onClick={handleRefresh}
              />
            </Button>

            <IoMdNotifications
              style={{ height: "27px", width: "27px", color: "#7367f0" }}
              onClick={() => navigate("/Notification")}
            />
          </div>
        </div>
      )}
      <Drawer open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </header>
  );
};

export default Header;
